import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFridge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFridge"><Path fillRule="evenodd" clipRule="evenodd" d="M4 10.25V2H20V10.25H4ZM16 5.5V8H14.5V5.5H16Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M4 11.75V22.25H20V11.75H4ZM16 16.5V14H14.5V16.5H16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFridge;
